import { b as __assign } from '../../../../_tslib-7a01aab4.js';
import React, { useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import '../../../core/enums/GameSpecificTypes.js';
import '../../../core/enums/MaxPayoutDataTypes.js';
import '../../../core/enums/Chat.js';
import '../../../core/enums/GameModes.js';
import '../../../core/enums/IconTypes.js';
import '../../../core/enums/BetStatus.js';
import '../../../core/enums/PopupTypes.js';
import '../../../core/enums/ApiVersion.js';
import '../../../core/enums/RoundStatus.js';
import '../../../core/enums/FreeBetsStatus.js';
import '../../../core/enums/SocketEvents.js';
import { TranslationKeys } from '../../../core/enums/TranslationKeys.js';
import '../../../core/enums/TimeoutMaxValue.js';
import '../../../core/enums/ApiServiceTypes.js';
import '../../../core/enums/EnvironmentTypes.js';
import '../../../core/enums/DefaultQueryValues.js';
import '../../../core/enums/FreeBetWinningType.js';
import '../../../core/enums/DefaultQueryParams.js';
import '../../../core/enums/BetHistoryFilterTypes.js';
import '../../../core/enums/GameThemeTypes.js';
import '../../../core/enums/RequestStatus.js';
import '../../../core/enums/FetchDefaultPaths.js';
import { BetResponseCode } from '../../../core/enums/ResponseCodes.js';
import { numPadTypes } from '../../../core/enums/BogLineGameConfig.js';
import { isMobile } from '../../../core/helpers/isMobile.js';
import { a2 as betDataStore, $ as gameConfigStore, z as freeBetStore } from '../../../../validateBalanceOnBet-af4f4a9b.js';
import '../../../core/store/chatStore.js';
import '../../../core/store/wageringStore.js';
import '../../../core/store/roundInfoStore.js';
import '../../../core/store/userCountStore.js';
import '../../../core/store/gameResultStore.js';
import '../../../core/store/resultHashStore.js';
import '../../../core/store/userWinBetsStore.js';
import '../../../core/store/notificationStore.js';
import '../../../core/store/selectedResultInfoStore.js';
import { inputValidationStore } from '../../../core/store/forCrashGame/inputValidationStore.js';
import '../../../core/store/forCrashGame/totalBetStore.js';
import '../../../core/store/forCrashGame/resultReportStore.js';
import { gameStore } from '../../../core/store/forCrashGame/gameStore.js';
import '../../../core/services/liveConnection/types.js';
import 'axios';
import '../../../core/services/sound/types.js';
import '../../../core/services/sound/SoundService.js';
import '../../../core/services/sound/defaultSounds.js';
import '../../../core/services/api/types.js';
import '../../../core/services/ApiServices.js';
import '../../../../momentFormat-e9197995.js';
import '../../../core/polyfill.js';
import { checkMaxAutoCashOutValue } from '../../../core/helpers/checkMaxAutoCashOutValue.js';
import '../../../contexts/TranslationContext.js';
import '../../../contexts/StoreContext.js';
import { useTranslation } from '../../../hooks/useTranslation.js';
import { useAmountValidation } from '../../../hooks/useAmountValidation.js';
import '../../../core/enums/additionalInputValueChangingButtons.js';
import 'mobx';
import '../../../core/classes/httpResponse/index.js';
import '@microsoft/signalr';
import '../../../core/helpers/parseQuery.js';
import '../../../core/enums/StatisticsSortingTypes.js';
import '../../../core/services/api/BaseApiService.js';
import '../../../core/helpers/deepCopy.js';
import '../../../../table-line/t_types/enums/BetResponseCode.js';
import '../../../../table-line/t_types/enums/BetErrorMessages.js';
import '../../../../table-line/t_types/enums/NotificationByResponseCode.js';
import '../../../../table-line/t_types/enums/FreeChipTypes.js';
import '../../../../table-line/t_types/enums/PopupTypes.js';
import '../../../core/helpers/formatDate.js';
import '../../../core/enums/bogGameNames.js';
import '../../../core/helpers/updateHalfBets.js';
import 'howler';
import '../../../../_commonjsHelpers-17aad09c.js';
import '../../../core/helpers/setTranslationValues.js';

var AutoCashOut = observer(function (_a) {
    var sectionIndex = _a.sectionIndex, handleOpenNumPad = _a.handleOpenNumPad;
    var t = useTranslation();
    var AutoCashOut = TranslationKeys.AutoCashOut;
    var setAutoCashOutOdd = betDataStore.setAutoCashOutOdd, setIsAutoCashOutOpen = betDataStore.setIsAutoCashOutOpen, betsSectionsData = betDataStore.betsSectionsData;
    var _b = betsSectionsData[sectionIndex], betAmount = _b.betAmount, autoCashOutOdd = _b.autoCashOutOdd, isAutoCashOut = _b.isAutoCashOut, index = _b.index;
    var limits = gameConfigStore.limits;
    var minOdd = gameStore.minOdd;
    var activeFreeBet = freeBetStore.activeFreeBet;
    var params = {
        storeValue: autoCashOutOdd,
        minValue: (activeFreeBet === null || activeFreeBet === void 0 ? void 0 : activeFreeBet.minOdd) ? activeFreeBet.minOdd : minOdd,
        maxValue: checkMaxAutoCashOutValue(betAmount, limits.maxWin),
        incDec: 0.1,
    };
    useEffect(function () {
        var maxAutoCashOutValue = checkMaxAutoCashOutValue(betAmount, limits.maxWin);
        if (isAutoCashOut && autoCashOutOdd > maxAutoCashOutValue && betAmount <= limits.maxBet) {
            var maxValue = maxAutoCashOutValue > minOdd ? maxAutoCashOutValue : minOdd;
            params.maxValue = maxValue;
            setAutoCashOutOdd(maxValue, index);
        }
    }, [betAmount, isAutoCashOut]);
    var onChangeAutoCashOut = function (changeValue) {
        betDataStore.setAutoCashOutOdd(changeValue, index);
    };
    var onChangeAutoCashOutOdd = useAmountValidation(onChangeAutoCashOut, null).simpleOnChange; // todo avelacnel interface
    var onBlur = function (e) {
        var _a;
        inputValidationStore.setDefaultValue((_a = e.target) === null || _a === void 0 ? void 0 : _a.value.trim(), betDataStore.setAutoCashOutOdd, params, index, {
            minOdd: BetResponseCode.InValidAutoCashOutOdd,
            maxOdd: BetResponseCode.InValidMaxAutoCashOutOdd,
        });
    };
    return (React.createElement("div", { className: 'aviabet-bet-section-auto-cashout' },
        React.createElement("div", { className: 'aviabet-bet-section-auto-cashout-block' },
            React.createElement("div", { className: 'switcher-wrp' },
                React.createElement("input", { type: 'checkbox', id: "cashout".concat(index), className: 'switcher-input', checked: isAutoCashOut }),
                React.createElement("label", { onClick: function () { return setIsAutoCashOutOpen(!isAutoCashOut, index); }, htmlFor: "cashout".concat(index), className: 'switcher-inside' },
                    React.createElement("span", { className: 'switcher-inner' })))),
        React.createElement("div", { className: 'avi-bet-auto-cashout-amount-block' }, isAutoCashOut ? (React.createElement("input", __assign({ className: 'avi-bet-auto-cashout-input', type: 'text', readOnly: isMobile(), inputMode: isMobile() ? 'none' : 'text', autoComplete: 'off', maxLength: 9, value: autoCashOutOdd, onChange: onChangeAutoCashOutOdd, onBlur: onBlur, onPaste: function (e) {
                e.preventDefault();
            } }, (isMobile()
            ? {
                onClick: function (e) { return handleOpenNumPad(e, numPadTypes.autoCashOutOdd, index, params); },
            }
            : {})))) : (React.createElement("p", { className: 'avi-bet-section-auto-cashout-txt' }, t(AutoCashOut))))));
});

export { AutoCashOut };
